import { IconUpload } from '@/components/design/icons';
import type { FileDropAction } from './types';
import { useAuthStore } from '@/stores/auth';
import StartReviewDropFlow from './StartReviewDropFlow.vue';

/**
 * Upload the dropped files and start a contract review. It is a "complex"
 * action — it delegates to its own component, which drives the existing
 * StartAnalysisModal flow. Offered when the org has contract review enabled
 * (the modal still guards the actual run by the user's review permission).
 */
export const startReviewAction: FileDropAction = {
  key: 'start-review',
  label: 'Start a review',
  icon: IconUpload,
  component: StartReviewDropFlow,
  isAvailable: () => useAuthStore().canUseReviewArea,
};
